import React from 'react';
import get_bundle from '../../domain/get_bundle';
import Locale from '../../domain/Locale';
import URL from '../../domain/URL';
import User from '../../domain/User';
import Color from '../../domain/Color';
import Gender from '../../domain/Gender';
import SponsorDomain from '../../domain/Sponsor';
import countries from '../../domain/countries';
import UserHeader from '../../components/header/User';
import Layout from '../../components/Layout';
import Sponsor from '../../components/Sponsor';
import Message from '../../components/Message';
import MarkdownComponent from '../../components/MarkdownComponent';
import { t, props } from 'tcomb-react';

@props({
  locale: Locale,
  districts: t.Arr,
  country: t.Str,
  sponsor: t.maybe(SponsorDomain),
  loadDistricts: t.Func,
  lib_url: URL,
  doVerify: t.Func,
  user: User,
  themeBtnColor: t.maybe(Color),
  themeBgColor: t.maybe(Color),
  themeBgFontColor: t.maybe(Color),
  themeBtnFontColor: t.maybe(Color),
  goProduct: t.Func,
  goChangePassword: t.Func,
  goPurchases: t.Func,
  doLogout: t.Func,
  doAcceptCookies: t.Func,
  partners: t.maybe(t.Obj)
})
export default class Verify extends React.Component {

  constructor(...args) {
    super(...args);
    this.districts = this.props.districts;
    const value = this.getValue(this.props.country);
    this.state = {
      options: this.getOptions(value),
      value
    };
  }

  getBgColor() {
    if (!this.props.sponsor) {
      return null;
    }
    return this.props.sponsor.bg_color;
  }

  getColor() {
    if (!this.props.sponsor) {
      return null;
    }
    return this.props.sponsor.color;
  }

  onChange = (value) => {
    if (value.country) {
      if (value.country !== this.state.value.country) {
        this.props.loadDistricts(value.country, (districts) => {
          this.districts = districts;
          value.district = null;
          this.setState({
            value,
            options: this.getOptions(value)
          });
        });
      } else {
        this.setState({
          value
        });
      }
    } else {
      this.setState({
        value,
        options: this.getOptions(value)
      });
    }
  }

  onSubmit = (evt) => {
    evt.preventDefault();
    const value = this.refs.form.getValue();
    if (value) {
     this.props.doVerify(
        value.gender,
        value.birth_date.getTime(),
        value.country,
        value.district,
        value.zip
      );
    }
  };

  getValue(country) {
    return {
      gender: null,
      birth_date: null,
      country: country,
      district: null,
      zip: null
    };
  }

  getDistrictsArray() {
    return this.districts.map((district) => {
      return district[0];
    });
  }

  getCountriesArray() {
    const countriesElements = [];
    for(const country in countries.data) {
      countriesElements.push(country);
    }
    return countriesElements;
  };

  getFormType() {
    const districtsArray = this.getDistrictsArray();
    const District = t.enums.of(districtsArray);

    const countriesArray = this.getCountriesArray();
    const CountryDomain = t.enums.of(countriesArray);

    return t.struct({
      gender: Gender,
      birth_date: t.Dat,
      country: CountryDomain,
      district: District,
      zip: t.Str
    }, 'Verify');
  }

  getGenderOptions() {
    return get_bundle(this.props.locale).user.gender_options.map((option) => {
      return {
        value: option[0],
        text: option[1]
      };
    });
  }

  getCountriesOptions() {
    return countries.to_options(this.props.locale).map((country) => {
      return {
        value: country[0],
        text: country[1]
      };
    });
  }

  getDistrictsOptions(country) {
    if (!country) {
      return [];
    }

    return this.districts.map((district) => {
      return {
        value: district[0],
        text: district[1]
      };
    });
  }

  getOptions(value) {
    const locale = this.props.locale;
    const bundle = get_bundle(locale).user;
    return {
      fields: {
        gender: {
          label: bundle.gender,
          options: this.getGenderOptions()
        },
        birth_date: {
          label: bundle.birth_date,
          order: locale.getTcombFormDateOrder()
        },
        country: {
          label: bundle.country,
          options: this.getCountriesOptions(),
          help: bundle.country_hint
        },
        district: {
          label: bundle.district,
          options: this.getDistrictsOptions(value.country)
        },
        zip: {
          label: bundle.zip
        }
      }
    };
  };

  getMobile() {
    return countries.format_mobile(this.props.country, this.props.mobile);
  };

  getHeader() {
    return (
      <UserHeader
        locale={this.props.locale}
        goPurchases={this.props.goPurchases}
        goChangePassword={this.props.goChangePassword}
        doLogout={this.props.doLogout}
        goProduct={this.props.goProduct}
        user={this.props.user}
        color={this.getColor()}
        themeBtnColor={this.props.themeBtnColor}
        themeBtnFontColor={this.props.themeBtnFontColor} />);
  }

  getSponsor() {
    const options = {
      showTutorial: false
    };
    return (<Sponsor sponsor={this.props.sponsor} locale={this.props.locale} options={options} />);
  }

  getSxContent() {
    const bundle = get_bundle(this.props.locale).verify;
    return (
      <div className="left-image">
        <div className="left-claim">
          <div className="cell">
            <MarkdownComponent>{bundle.claim.call_to_action}</MarkdownComponent>
          </div>
          <div className="cell">
            <MarkdownComponent>{bundle.claim.safe}</MarkdownComponent>
          </div>
        </div>
      </div>
    );
  }

  getMessage() {
    return (<Message bgColor={this.props.themeBgColor} fontColor={this.props.themeBgFontColor}>{get_bundle(this.props.locale).verify.title}<br/>{get_bundle(this.props.locale).verify.sub_title}</Message>);
  }


  render() {
    const locale = this.props.locale;
    const bundle = get_bundle(locale).verify;

    const btnStyle = {
      backgroundColor: this.props.themeBtnColor,
      color: this.props.themeBtnFontColor
    };

    return (
      <Layout header={this.getHeader()} partners={this.props.partners} sponsor={this.getSponsor()} bgColor={this.getBgColor()} locale={locale} doAcceptCookies={this.props.doAcceptCookies}>
        <div id="verify" className="cols">
          <div className="large-100">
            <div className="large-60 small-hide">
              <div className="cell">
                { this.getSxContent() }
              </div>
            </div>
            <div className="large-40 large-pull-right small-100">
              <div className="cell border-radius-all">
                { this.getMessage() }
                <div className="box light">
                  <form onSubmit={this.onSubmit}>
                    <t.form.Form
                      ref="form"
                      type={this.getFormType()}
                      options={this.state.options}
                      value={this.state.value}
                      onChange={this.onChange} />
                    <button className="btn" style={btnStyle}>{bundle.do_verify}</button>
                   </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/product/route/Verify.js
 **/